<template>
  <div
    v-if="data.length > 0"
    :class="`${index !== 0 ? 'tw-mt-[30px]' : ''} ${
      index === 2 ? 'tw-mb-[40px]' : ''
    }`"
  >
    <span class="tw-text-[#878787] tw-text-[10px] title-block">{{
      getComponentUiText(title)
    }}</span>
    <div class="notification-box tw-mt-[15px]">
      <div v-for="(notification, idxItem) in data" :key="idxItem">
        <notificationItem :index="idxItem" :notification="notification" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import notificationItem from "./notificationItem.vue";
import { getComponentUiText } from "../../utils/utilities";

defineProps({
  data: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  index: {
    type: [Number, String],
    required: true,
  },
  sortAsc: {
    type: Boolean,
    required: false,
  },
});
</script>

<style scoped lang="scss">
.title-block {
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 1px;
  text-transform: uppercase;
}
.notification-box {
  border-radius: 4px;
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-white, #fff);
  border-bottom: none;
}
</style>
